import type { ReactElement } from "react"
import { loadIcon as loadHomeIcon } from "@ionos-web-design-system/icon/homepl/loader"
import { loadIcon as loadSystemIcon } from "@ionos-web-design-system/icon/system/loader"
import {
  type IconModuleLoader,
  Skeleton,
  useDynamicIcon,
} from "@ionos-web-design-system/react"
import Icon, {
  type BrandSize,
  brandIconSizeMap,
  type IconProps,
  type StandardSize,
  standardIconSizeMap,
} from "@ionos-web-design-system/react/icon"

export type DynamicUdsIconGroup = "system" | "homepl"
export const ICON_GROUP_SQUIDEX_TYPE: Partial<
  Record<string, DynamicUdsIconGroup>
> = {
  GraphCmsSquidex_SystemUdsIconsComponent: "system",
  SystemUdsIconsComponent: "system",
  GraphCmsSquidex_BrandUdsIconsComponent: "homepl",
  BrandUdsIconsComponent: "homepl",
}

export type DynamicUdsIconProps = Omit<IconProps, "icon"> & {
  iconName: string
  iconGroup?: DynamicUdsIconGroup
}

const LOADERS: Record<DynamicUdsIconGroup, IconModuleLoader> = {
  system: loadSystemIcon,
  homepl: loadHomeIcon,
}

export default function DynamicUdsIcon({
  iconName,
  iconGroup = "system",
  size = "medium",
  ...rest
}: DynamicUdsIconProps): ReactElement<DynamicUdsIconProps> | null {
  const { icon, isLoading } = useDynamicIcon(LOADERS[iconGroup], iconName)

  if (isLoading) {
    const sizePx =
      iconGroup === "homepl"
        ? (brandIconSizeMap[size as BrandSize] ?? brandIconSizeMap.medium)
        : (standardIconSizeMap[size as StandardSize] ??
          standardIconSizeMap.medium)

    return <Skeleton variant="rectangle" width={sizePx} height={sizePx} />
  }

  if (!icon) return null

  return <Icon icon={icon} size={size} {...rest} />
}
